module.exports = __webpack_public_path__ + "img/Postmodernisme_Kjartan-Flogstad.37e89ce9.jpg";